var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgALogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 59,
    viewBox: "0 0 67 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AFCA15",
    d: "M11.03 27.9c-1.95-1.32-3.66-1.32-5.06.21-1.04 1.14-1.27 3.03.09 4.4L26.89 55.6c1.78 1.78 3.56 2.62 4.75 2.64V41.35L11.03 27.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1452FF",
    d: "M38.93.81H24.34L.17 58.65h15.28l4.06-10.53h.03l12.14-31.26 7.42 19h-.04l4.79 12.26 4.06 10.53H63.1L38.93.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#195284",
    d: "m51.64 31.21 1.75 4.19-9.91 11.76-.42-1.09 8.58-14.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8D40B",
    d: "M64.95 5.5a3.39 3.39 0 0 0-4.8.24L31.64 41.36v16.89c3.76 0 5.88-3.06 5.88-3.06L65.47 9.95c.95-1.38.75-3.29-.52-4.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgALogo);
export default __webpack_public_path__ + "static/media/a-logo.efdbbe3f089b89aecdc619548747b86c.svg";
export { ForwardRef as ReactComponent };